import { apiCall } from "../../store/services/service";
import { BASE_URL } from "../../store/services/URL";

const resourcePlannerService = {
  /**
   * GET /resources/planner
   * @param {Object} params - { startDate, endDate, projectId?, resources?, pageNumber?, pageSize? }
   */
  getPlanner(params) {
    const { startDate, endDate, projectId, resources, pageNumber = 1, pageSize = 10 } = params;
    const query = new URLSearchParams();
    query.append("startDate", startDate);
    query.append("endDate", endDate);
    query.append("pageNumber", pageNumber);
    query.append("pageSize", pageSize);
    if (projectId) query.append("projectId", projectId);
    if (resources && resources.length > 0) {
      query.append("resources", resources.join(","));
    }
    return apiCall.get({
      url: `${BASE_URL}resources/planner?${query.toString()}`,
      isAuthToken: true,
    });
  },

  /**
   * PUT /tasks/{taskId}/allocations/{resourceId}
   * @param {string} taskId
   * @param {string} resourceId
   * @param {Object} body - { startDate, endDate }
   */
  updateAllocation(taskId, resourceId, body) {
    return apiCall.put({
      url: `${BASE_URL}tasks/${taskId}/allocations/${resourceId}`,
      params: body,
    });
  },
};

export default resourcePlannerService;
